import { useCallback, useState } from "react";
import { useAuth } from "@/auth/AuthContext.jsx";
import "./guest-auth-prompt.css";

const STORAGE_KEY = "guestAuthPromptDismissed";

export function useGuestAuthPrompt() {
    const { isAuthenticated } = useAuth();
    const [dismissed, setDismissed] = useState(() => {
        try {
            return localStorage.getItem(STORAGE_KEY) === "1";
        } catch {
            return false;
        }
    });

    const dismiss = useCallback(() => {
        try {
            localStorage.setItem(STORAGE_KEY, "1");
        } catch {
            // ignore quota / private mode
        }
        setDismissed(true);
    }, []);

    const isGuest = !isAuthenticated;
    return {
        showModal: false,
        showBanner: isGuest,
        dismiss
    };
}

export function GuestAuthModal({ onLogin, onRegister, onDismiss }) {
    return (
        <div
            className="guest-auth-modal-backdrop"
            role="dialog"
            aria-modal="true"
            aria-labelledby="guest-auth-modal-title"
            onClick={onDismiss}
        >
            <div className="guest-auth-modal card" onClick={(event) => event.stopPropagation()}>
                <div className="guest-auth-modal-header">
                    <h2 id="guest-auth-modal-title">Bienvenue</h2>
                    <button type="button" className="link-btn" onClick={onDismiss}>
                        Fermer
                    </button>
                </div>
                <p className="guest-auth-modal-text">
                    Créez un compte ou connectez-vous pour commander, suivre vos achats et enregistrer vos adresses.
                </p>
                <div className="guest-auth-actions">
                    <button type="button" className="btn btn-primary" onClick={onRegister}>
                        Créer un compte
                    </button>
                    <button type="button" className="btn btn-secondary" onClick={onLogin}>
                        Se connecter
                    </button>
                </div>
                <button type="button" className="link-btn guest-auth-dismiss" onClick={onDismiss}>
                    Continuer sans compte
                </button>
            </div>
        </div>
    );
}

export function GuestAuthBanner({ onLogin, onRegister }) {
    return (
        <div className="guest-auth-banner" role="region" aria-label="Connexion ou inscription" data-tour="guest-auth-banner">
            <div className="container guest-auth-banner-inner">
                <p className="guest-auth-banner-text">
                    Créez un compte ou connectez-vous pour commander et suivre vos achats.
                </p>
                <div className="guest-auth-banner-actions">
                    <button type="button" className="btn btn-primary guest-auth-banner-btn" onClick={onRegister}>
                        Créer un compte
                    </button>
                    <button type="button" className="btn btn-secondary guest-auth-banner-btn" onClick={onLogin}>
                        Se connecter
                    </button>
                </div>
            </div>
        </div>
    );
}
